/**
 * Resuelve el content-type real de un archivo.
 *
 * Muchos remitentes envían adjuntos con `application/octet-stream` en la cabecera
 * Content-Type (un PDF marcado como binario genérico). Ese valor viaja desde el
 * proveedor de correo hasta la subcolección files/ del email y de ahí al embarque
 * o a la orden de compra, dejando documentos que no se previsualizan.
 */

/** Tipos que no identifican el formato: hay que deducirlo por la extensión. */
const GENERIC_MIME_TYPES = new Set([
  'application/octet-stream',
  'binary/octet-stream',
  'application/binary',
  'application/unknown',
])

const MIME_BY_EXTENSION: Record<string, string> = {
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  bmp: 'image/bmp',
  webp: 'image/webp',
  tif: 'image/tiff',
  tiff: 'image/tiff',
  svg: 'image/svg+xml',
  heic: 'image/heic',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xlsm: 'application/vnd.ms-excel.sheet.macroEnabled.12',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  csv: 'text/csv',
  txt: 'text/plain',
  xml: 'application/xml',
  json: 'application/json',
  html: 'text/html',
  htm: 'text/html',
  zip: 'application/zip',
  rar: 'application/vnd.rar',
  '7z': 'application/x-7z-compressed',
  eml: 'message/rfc822',
  msg: 'application/vnd.ms-outlook',
}

/** Devuelve el mime guardado si es específico; si no, lo deduce del nombre del archivo. */
export function resolveMimeType(
  storedMimeType: string | null | undefined,
  fileName: string | null | undefined
): string {
  const stored = (storedMimeType || '').trim()

  if (stored && !GENERIC_MIME_TYPES.has(stored.toLowerCase())) {
    return stored
  }

  const extension = (fileName || '').split('.').pop()?.toLowerCase() || ''
  return MIME_BY_EXTENSION[extension] || stored || 'application/octet-stream'
}
